<div class="bolt-container bolt-space-bottom-2xl">

  <bolt-progress-bar appFocusOnInit arialabel="Stop next automatic payment progress value is 100%" value="100" class="progress-bar-container to-container"></bolt-progress-bar>
  <h1 class="bolt-heading-primary bolt-space-bottom-2xl">Stop next automatic payment: confirmation</h1>

  @if (!suspendEasyPayError && dueDate) {
    <div class="bolt-space-bottom-2xl">
      <bolt-notification type="success">
        <span class="success-notification">
          We have paused your automatic payment for this billing cycle only. Please be sure to <a href="javascript:void(0)" (click)="onMakeAPayment()">make a payment</a> before your due date
          on {{displayMessageForForm}}. We will resume automatic payments for your next billing cycle.
        </span>
      </bolt-notification>
    </div>
    @if (nextDueAmount) {
      <app-payment-sub-header>Next steps</app-payment-sub-header>
      <div class="bolt-row">
        <div class="bolt-col">
          <strong>Make a payment by:</strong>
        </div>
        <div class="bolt-col">
          {{displayMessageForForm}}
        </div>
      </div>
      <div class="bolt-row">
        <div class="bolt-col">
          <strong>Amount due:</strong>
        </div>
        <div class="bolt-col">
          {{nextDueAmount | currency:'USD' }}
        </div>
      </div>
    }
  }
  @if (apiCallFailed) {
    <bolt-notification type="error">
      <span class="error-notification">{{ apiServiceDownMessage }}</span>
    </bolt-notification>
  }
</div>

<bolt-button-bar>
  <is-button id="print-button" slot="cancel" (click)="showPrintDialog()">Print</is-button>
  <is-button id="pay-later-button" slot="back" (click)="onPayLater()">Pay later</is-button>
  <is-button id="make-a-payment-button" slot="forward" (click)="onMakeAPayment()" type="solid">
    Make a payment
  </is-button>
</bolt-button-bar>